/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coveradjustzoom2Inputs */

const en_coveradjustzoom2 = /** @type {(inputs: Coveradjustzoom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const de_coveradjustzoom2 = /** @type {(inputs: Coveradjustzoom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößern`)
};

/**
* | output |
* | --- |
* | "Zoom" |
*
* @param {Coveradjustzoom2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coveradjustzoom2 = /** @type {((inputs?: Coveradjustzoom2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coveradjustzoom2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coveradjustzoom2(inputs)
	return de_coveradjustzoom2(inputs)
});
export { coveradjustzoom2 as "coverAdjustZoom" }